import {post} from '../../request'

/**
 * 用户列表
 * @param data
 * @returns {Promise<*>}
 */
export function getUserIndex(data) {
    return post("admin/user.index/index", data)
}


/**
 * 绑卡
 * @param data
 * @returns {Promise<*>}
 */
export function card(data) {
    return post("admin/user.index/card", data)
}


/**
 * 锁定用户
 * @param data
 * @returns {Promise<*>}
 */
export function lockUser(data) {
    return post("admin/user.index/lock", data)
}


/**
 * 搜索用户
 * @param data
 * @returns {Promise<*>}
 */
export function searchUser(data) {
    return post("admin/user.index/searchUser", data)
}
/**
 * 订单记录
 * @param data
 * @returns {Promise<*>}
 */
export function orderDetail(data) {
    return post("admin/user.index/orderDetail", data)
}

/**
 * 用户积分明细
 * @param data
 * @returns {Promise<*>}
 */
export function userPointsobtain(data) {
    return post("admin/user.index/userPointsobtain", data)
}
/**
 * 用户等级日志记录
 * @param data
 * @returns {Promise<*>}
 */
export function userlevelLog(data) {
    return post("admin/user.index/userlevelLog", data)
}
/**
 * 钱包日志
 * @param data
 * @returns {Promise<*>}
 */
export function journal(data) {
    return post("admin/user.index/journal", data)
}
/**
 * 上传收款码
 * @param data
 * @returns {Promise<*>}
 */
export function uploadCode(data) {
    return post("admin/user.index/uploadCode", data)
}
/**
 * 提现
 * @param data
 * @returns {Promise<*>}
 */
export function cashOut(data) {
    return post("admin/user.index/cashOut", data)
}
/**
 *
 * @param data
 * @returns {Promise<*>}
 */
export function UserfeedbackList(data) {
    return post("admin/user.Userfeedback/index", data)
}
/**
 *
 * @param data
 * @returns {Promise<*>}
 */
export function userFeedbackType(data) {
    return post("admin/user.Userfeedback/type", data)
}

/**
 * 
 * 设置处理结果
 */
export function SetProcessingResult(data) {
    return post("admin/user.Userfeedback/set_processing_result", data)
}

/**
 * 用户佣金
 * @param data
 * @returns {Promise<*>}
 */
export function UserCommissionList(data) {
    return post("admin/user.UserCommission/index", data)
}


/**
 * 用户红包
 * @param data
 * @returns {Promise<*>}
 */
export function getBonus(data) {
    return post("admin/user.Bonus/index", data)
}

/**
 * 用户分群
 * @param data
 * @returns {Promise<*>}
 */
export function getGroup(data) {
    return post("/admin/user.index/group", data)
}

/**
 * 用户分群查看
 * @param data
 * @returns {Promise<*>}
 */
export function groupseeList(data) {
    return post("/admin/user.index/groupsee", data)
}

/**
 * 用户标签列表
 * @param data
 * @returns {Promise<*>}
 */
export function taglist(data) {
    return post("/admin/user.usertag/index", data)
}

/**
 * 添加标签
 * @param data
 * @returns {Promise<*>}
 */
export function tagadd(data) {
    return post("/admin/user.usertag/add", data)
}

/**
 * 编辑标签
 * @param data
 * @returns {Promise<*>}
 */
export function tagedit(data) {
    return post("/admin/user.usertag/edit", data)
}

/**
 * 删除标签
 * @param data
 * @returns {Promise<*>}
 */
export function tagdelete(data) {
    return post("/admin/user.usertag/delete", data)
}

/**
 * 用户列表展示信息
 * @param data
 * @returns {Promise<*>}
 */
export function searchlist(data) {
    return post("/admin/user.index/searchlist", data)
}

/**
 * 设置标签
 * @param data
 * @returns {Promise<*>}
 */
export function settag(data) {
    return post("/admin/user.index/settag", data)
}

/**
 * 分群广告列表
 * @param data
 * @returns {Promise<*>}
 */
export function groupadlist(data) {
    return post("/admin/user.userstatisticalad/index", data)
}

/**
 * 分群广告状态启用
 * @param data
 * @returns {Promise<*>}
 */
export function groupadstatus(data) {
    return post("/admin/user.userstatisticalad/status", data)
}

/**
 * 分群广告列表展示信息
 * @param data
 * @returns {Promise<*>}
 */
export function groupadsearchlist(data) {
    return post("/admin/user.userstatisticalad/list", data)
}

/**
 * 分群广告状态添加
 * @param data
 * @returns {Promise<*>}
 */
export function groupadadd(data) {
    return post("/admin/user.userstatisticalad/add", data)
}

/**
 * 分群广告状态编辑
 * @param data
 * @returns {Promise<*>}
 */
export function groupadedit(data) {
    return post("/admin/user.userstatisticalad/edit", data)
}

/**
 * 分群广告状态删除
 * @param data
 * @returns {Promise<*>}
 */
export function groupaddelete(data) {
    return post("/admin/user.userstatisticalad/delete", data)
}

/**
 * 成交订单
 * @param data
 * @returns {Promise<*>}
 */
 export function getOrderstatistics(data) {
    return post("admin/order.Orderstatistics/log", data)
}

/**
 * 删除成交订单
 * @param data
 * @returns {Promise<*>}
 */
 export function deleteFhRecord(data) {
    return post("admin/sorting.Record/deleteFh", data)
}

/**
 * 注册统计
 * @param data
 * @returns {Promise<*>}
 */
 export function getOrderstatisticsRegister(data) {
    return post("admin/order.Orderstatistics/zhuce", data)
}

/**
 * 财务流水
 * @param data
 * @returns {Promise<*>}
 */
export function getFinancialFlow(data) {
    return post("admin/user.index/FinancialFlow", data)
}




